import React from "react";
import {
  animate,
  motion,
  useMotionValue,
  useTransform,
  useAnimation,
} from "framer-motion";
import { useEffect } from "react";

export type ProgressProps = {
  count: number;
  percent: number;
};

export const Progress: React.FC<ProgressProps> = ({ count, percent }) => {
  const controls = useAnimation();
  const x = useMotionValue(0);
  const input = [0, 1];
  const output = ["0%", "100%"];
  const w = useTransform(x, input, output);

  useEffect(() => {
    const a = animate(x, percent, { duration: 0.5 });
    return a.stop;
  }, [x, percent, controls]);

  return (
    <motion.div
      className="shindan-app__progress"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ type: "spring", duration: 0.5 }}
    >
      <motion.div
        animate={controls}
        className="shindan-app__progress__count"
        style={{ left: w }}
      >
        <span>残り</span>
        <span>
          <em>{count}</em>問
        </span>
      </motion.div>
      <div className="shindan-app__progress__rail">
        <motion.div
          className="shindan-app__progress__bar"
          style={{ width: w }}
        ></motion.div>
      </div>
    </motion.div>
  );
};
